/**
 * Cookie attributes for values that must be readable across Tamara subdomains
 * (e.g. PPUI on cko-staging → questionnaire-staging).
 *
 * Mirrors legacy checkout-ui `getTamaraDomainCookieAttributes`.
 */
export function getTamaraSharedCookieDomain(): string | undefined {
  if (typeof window === "undefined") {
    return undefined;
  }

  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") {
    return undefined;
  }

  if (host.endsWith("tamara.co")) {
    return ".tamara.co";
  }

  if (host.endsWith("tamaratech.co")) {
    return ".tamaratech.co";
  }

  return undefined;
}

export function getTamaraSharedCookieAttributes(): {
  path: string;
  sameSite: "lax";
  secure: boolean;
  domain?: string;
} {
  const domain = getTamaraSharedCookieDomain();

  return {
    path: "/",
    sameSite: "lax",
    secure: domain !== undefined,
    ...(domain ? { domain } : {}),
  };
}
